import { render } from "./patient-create.vue?vue&type=template&id=7339387f&scoped=true"
import script from "./patient-create.vue?vue&type=script&lang=js"
export * from "./patient-create.vue?vue&type=script&lang=js"

import "./patient-create.vue?vue&type=style&index=0&id=7339387f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7339387f"]])

export default __exports__